import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { GlobalStore } from '../../../store/global.global-store';
import { permissionsFetched } from '../../shared/shared.global-service';
import { Operations } from '@libs/types/src/authorization/enum/operation.enum';

export function agendaPermissionGuard(operation: Operations): CanActivateFn {
    return async () => {
        const store = inject(GlobalStore);
        const router = inject(Router);
        try {
            const ready = permissionsFetched() || await store.fetchAcl();
            if (ready && store.isAllowed(operation)()) return true;
        } catch {
            // Failed ACL refresh must deny direct access.
        }
        return router.createUrlTree(['/content/dashboard']);
    };
}
